export interface ResultsSummaryParams {
  page: number;
  pageSize: number;
  total: number;
  entityName?: string;
}

export interface ResultsSummaryRange {
  start: number;
  end: number;
  displayTotal: number;
}

export const getResultsRange = ({
  page,
  pageSize,
  total,
}: ResultsSummaryParams): ResultsSummaryRange => {
  const start = total === 0 ? 1 : (page - 1) * pageSize + 1;
  const end = total === 0 ? 1 : Math.min(page * pageSize, total);
  const displayTotal = total === 0 ? 1 : total;

  return { start, end, displayTotal };
};

export const getResultsSummaryText = (params: ResultsSummaryParams): string => {
  const { start, end, displayTotal } = getResultsRange(params);
  const { entityName } = params;

  return `${start} - ${end} of ${displayTotal} ${entityName ?? ''}`;
};
